import type { MaybeRefOrGetter } from 'vue';

import { SheetLevel } from '~/composables/useBottomSheet';
import { computed, toValue } from 'vue';

import { ctaPosition, handlePosition } from './variants';

export function useBottomSheetHandlePosition(input: {
	level: MaybeRefOrGetter<SheetLevel>;
	isDragging: MaybeRefOrGetter<boolean>;
	isTransitioning: MaybeRefOrGetter<boolean>;
}) {
	// No peek e em repouso, alça e CTA viram a barra fixa no rodapé da viewport.
	const isPeekAtRest = computed(
		() =>
			toValue(input.level) === SheetLevel.FULLY_OPEN &&
			!toValue(input.isDragging) &&
			!toValue(input.isTransitioning)
	);

	const handlePositionClass = computed(() =>
		handlePosition({ state: isPeekAtRest.value ? 'peek' : 'anchored' })
	);

	const ctaPositionClass = computed(() =>
		ctaPosition({ state: isPeekAtRest.value ? 'peek' : 'hidden' })
	);

	return { isPeekAtRest, handlePositionClass, ctaPositionClass };
}
